export const CoffeeRedirect = () => {
  window.location.replace('/');
  return null;
};
